import VuexPersistence from 'vuex-persist'

export default new VuexPersistence({
	key: 'session',
	storage: window.localStorage,
	reducer: currentState => ({
		session: {
			jwt: currentState.session.jwt,
			refresh: currentState.session.refresh,
			expires: currentState.session.expires,
		},
	}),
}).plugin
